import React from "react"
import type * as SentryReact from "@sentry/react"
import type * as SentryNode from "@sentry/node"

export type Sentry = typeof SentryReact | typeof SentryNode

export const SentryContext = React.createContext<Sentry | undefined>(undefined)

export const useSentry = (): Sentry => {
  const sentry = React.useContext(SentryContext)

  if (!sentry) {
    throw new Error("SentryContext not found")
  }

  return sentry
}
